import { render, staticRenderFns } from "./wdxdr.vue?vue&type=template&id=bef9e694&scoped=true&"
import script from "./wdxdr.vue?vue&type=script&lang=js&"
export * from "./wdxdr.vue?vue&type=script&lang=js&"
import style0 from "./wdxdr.vue?vue&type=style&index=0&id=bef9e694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef9e694",
  null
  
)

export default component.exports